import React, { useState } from 'react';

import { observer } from 'mobx-react';
import { Button, Dialog, DialogActions, DialogTitle, TextField } from '@mui/material';

import {
  CampChurch,
  StudygroupCollectionDocument,
  usePaymentsQuery,
  useRefundPaymentMutation,
  useUpdatePersonStudygroupMutation,
} from '../../generated/graphql';
import { getPersonDisplayName } from '../../helpers/persons/getPersonDetails';
import { PaddedHorizontalView } from '../common/CommonDivs';
import { useLatestValue } from '../../hooks/useLatestValue';
import { useStores } from '../../stores';


export const RefundModal = observer(function RefundModal() {
  const stores = useStores();
  const store = stores.paymentStore;
  const activeRefundPayment = store.activeRefundPayment;

  const [amount, setAmount] = useState<number>(activeRefundPayment?.amount || 0);
  const [reason, setReason] = useState<string>(activeRefundPayment?.reason || '');

  const handleCancel = () => {
    store.setActiveRefundPayment(null);
  }
  const [refundPayment] = useRefundPaymentMutation()

  console.log('activeRefundPayment', activeRefundPayment);


  const handleRefundPayment = () => {
    if (!activeRefundPayment) {
      throw new Error('Ingen betalning hittades');
    }
    refundPayment({     
      variables: {
        id: activeRefundPayment.id,
        amount: amount,
        reason: reason
      },
    }).then(() => {
      store.setActiveRefundPayment(null);
      store.setAmount(0);

        const { data } = usePaymentsQuery(
          { variables: { camp_id: activeRefundPayment?.camp_id } },
        );

        if (data && data.payments) {
          store.setPayments(data.payments);
        }

    });
  };


  return (
    <Dialog
      open={!!activeRefundPayment}
      maxWidth="xs"
      fullWidth
      // disableBackdropClick
      onClose={handleCancel}
      aria-labelledby="modal-title"
    >
      <>
        <DialogTitle id="modal-title">
         Återbetalning swish
        </DialogTitle>
        <PaddedHorizontalView>
          Summa:<br />
           <TextField onChange={(e) => setAmount(parseInt(e.target.value))} value={amount} type="number" placeholder="0" size="small">

           </TextField><br />
           Anledning:<br />
           <TextField onChange={(e) => setReason(e.target.value)} value={reason} type="text" placeholder="Anledning" size="small">

           </TextField><br />

          <Button
              onClick={handleRefundPayment}
              color="primary"
              type="button"
              size="medium"
            >
              Återbetala
            </Button>

        </PaddedHorizontalView>
        <DialogActions>
          <Button onClick={handleCancel} color="secondary" type="button">
            Stäng
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
});
